<template>
  <div class="channel-detail" v-loading="loading">
    <!-- 顶部操作栏 -->
    <div class="detail-header">
      <div class="header-left">
        <el-button icon="el-icon-back" @click="goBack">返回</el-button>
        <span class="header-title">渠道详情</span>
        <el-tag :type="getStatusType(channelInfo.status)" class="ml-10">
          {{ channelInfo.status | filterConst('CHANNEL_STATUS') }}
        </el-tag>
      </div>
      <div class="header-right">
        <el-button icon="el-icon-refresh" @click="refresh">刷新</el-button>
        <el-button type="primary" icon="el-icon-edit" @click="handleEdit" v-if="btnPreFn('channel_edit')">编辑</el-button>
        <el-button type="success" icon="el-icon-check" @click="handleEnable"
          v-if="channelInfo.status === 2 && btnPreFn('channel_enable')">启用</el-button>
        <el-button type="warning" icon="el-icon-close" @click="handleDisable"
          v-if="channelInfo.status === 1 && btnPreFn('channel_disable')">禁用</el-button>
      </div>
    </div>

    <!-- 基本信息和证件照片 -->
    <el-row :gutter="16" class="info-section">
      <!-- 左侧：基本信息 -->
      <el-col :span="14">
        <el-card shadow="never" class="info-card">
          <div slot="header" class="card-header-new">
            <span><i class="el-icon-user"></i> 基本信息</span>
          </div>
          <el-descriptions :column="2" border size="small">
            <el-descriptions-item label="渠道编号">
              <span class="info-value">{{ channelInfo.channelNo }}</span>
              <el-button type="text" size="mini" icon="el-icon-document-copy"
                @click="$utils.copyText(channelInfo.channelNo)">复制</el-button>
            </el-descriptions-item>
            <!-- <el-descriptions-item label="机构名称">
              <span class="info-value">{{ channelInfo.organizationName || '-' }}</span>
            </el-descriptions-item> -->
            <el-descriptions-item label="姓名">
              <span class="info-value">{{ channelInfo.name }}</span>
            </el-descriptions-item>
            <el-descriptions-item label="手机号">
              <span class="info-value">{{ channelInfo.phone }}</span>
              <el-button type="text" size="mini" icon="el-icon-document-copy"
                @click="$utils.copyText(channelInfo.phone)">复制</el-button>
            </el-descriptions-item>
            <el-descriptions-item label="身份证号">
              <span class="info-value">{{ channelInfo.idCard }}</span>
              <el-button type="text" size="mini" icon="el-icon-document-copy"
                @click="$utils.copyText(channelInfo.idCard)">复制</el-button>
            </el-descriptions-item>
            <el-descriptions-item label="工作区域">
              <div class="info-value" style="padding:4px 0;">{{ channelInfo.workArea || '-' }}</div>
            </el-descriptions-item>
            <el-descriptions-item label="支付宝账号">
              <span class="info-value">{{ channelInfo.alipayAccount || '-' }}</span>
            </el-descriptions-item>
            <el-descriptions-item label="支付宝姓名">
              <span class="info-value">{{ channelInfo.alipayName || '-' }}</span>
            </el-descriptions-item>
            <el-descriptions-item label="注册时间">
              <div class="info-value" style="padding:4px 0;">{{ channelInfo.created | filterTime }}</div>
            </el-descriptions-item>
            <el-descriptions-item label="状态">
              <el-tag :type="getAuditStatusType(channelInfo.status)" size="small">
                {{ channelInfo.status | filterConst('CHANNEL_STATUS') }}
              </el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="审核时间" :span="2">
              <span class="info-value">{{ channelInfo.auditTime | filterTime }}</span>
            </el-descriptions-item>
            <el-descriptions-item label="备注" :span="2">
              <span class="info-value">{{ channelInfo.remark }}</span>
            </el-descriptions-item>

          </el-descriptions>
        </el-card>
      </el-col>

      <!-- 右侧：证件照片 -->
      <el-col :span="10">
        <el-card shadow="never" class="info-card photo-card">
          <div slot="header" class="card-header-new">
            <span><i class="el-icon-picture"></i> 证件照片</span>
          </div>
          <div class="image-gallery">
            <div class="image-item">
              <div class="image-label">身份证正面</div>
              <div class="image-wrapper id-card-wrapper" @click="previewImage('idCardFront')">
                <el-image :src="getIdCardImageUrl(channelInfo.idCardFront) || idCardFrontPlaceholder" fit="cover"
                  :preview-src-list="[getIdCardImageUrl(channelInfo.idCardFront) || idCardFrontPlaceholder]">
                  <div slot="error" class="image-placeholder">
                    <img :src="idCardFrontPlaceholder" alt="身份证正面" />
                  </div>
                </el-image>
              </div>
            </div>
            <div class="image-item">
              <div class="image-label">身份证反面</div>
              <div class="image-wrapper id-card-wrapper" @click="previewImage('idCardBack')">
                <el-image :src="getIdCardImageUrl(channelInfo.idCardBack) || idCardBackPlaceholder" fit="cover"
                  :preview-src-list="[getIdCardImageUrl(channelInfo.idCardBack) || idCardBackPlaceholder]">
                  <div slot="error" class="image-placeholder">
                    <img :src="idCardBackPlaceholder" alt="身份证反面" />
                  </div>
                </el-image>
              </div>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <!-- 业务数据标签页 -->
    <el-card shadow="never" class="tabs-card">
      <el-tabs v-model="activeTab" @tab-click="tabClick">
        <el-tab-pane label="业务数据" name="business">
          <el-row :gutter="16">
            <el-col :span="6">
              <div class="stat-card primary">
                <div class="stat-icon">
                  <i class="el-icon-s-order"></i>
                </div>
                <div class="stat-content">
                  <div class="stat-label">订单总数</div>
                  <div class="stat-value">{{ channelInfo.orderCount || 0 }}</div>
                  <div class="stat-sub">本月: {{ statistics.monthOrderCount || 0 }}</div>
                </div>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="stat-card success">
                <div class="stat-icon">
                  <i class="el-icon-coin"></i>
                </div>
                <div class="stat-content">
                  <div class="stat-label">累计佣金</div>
                  <div class="stat-value">¥{{ channelInfo.totalCommission | filterMoney }}</div>
                  <div class="stat-sub">本月: ¥{{ statistics.monthCommission | filterMoney }}</div>
                </div>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="stat-card warning">
                <div class="stat-icon">
                  <i class="el-icon-money"></i>
                </div>
                <div class="stat-content">
                  <div class="stat-label">累计提现</div>
                  <div class="stat-value">¥{{ statistics.totalWithdrawal | filterMoney }}</div>
                  <div class="stat-sub">本月: ¥{{ statistics.monthWithdrawal | filterMoney }}</div>
                </div>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="stat-card balance">
                <div class="stat-icon">
                  <i class="el-icon-wallet"></i>
                </div>
                <div class="stat-content">
                  <div class="stat-label">账户余额</div>
                  <div class="stat-value">¥{{ channelInfo.balance | filterMoney }}</div>
                  <div class="stat-sub">待结算: ¥{{ statistics.pendingCommission | filterMoney }}</div>
                </div>
              </div>
            </el-col>
          </el-row>
        </el-tab-pane>
         <el-tab-pane label="最近订单" name="orders">
           <div style="text-align: right; margin-bottom: 8px;">
             <el-button type="text" @click="viewAllOrders">查看全部订单 <i class="el-icon-arrow-right"></i></el-button>
           </div>
           <el-table :data="recentOrders" border height="calc(100vh - 480px)">
             <el-table-column label="订单编号" prop="orderNo" min-width="150" align="left"></el-table-column>
             <el-table-column label="线路" prop="lineName" min-width="120" align="left"></el-table-column>
             <el-table-column label="乘客" prop="passengerName" min-width="100" align="left"></el-table-column>
             <el-table-column label="订单金额" min-width="100" align="left">
               <template slot-scope="{row}">
                 ￥{{ row.orderAmount | filterMoney }}
               </template>
             </el-table-column>
             <el-table-column label="佣金金额" min-width="100" align="left">
               <template slot-scope="{row}">
                 ￥{{ row.commissionAmount | filterMoney }}
               </template>
             </el-table-column>
             <el-table-column label="支付方式" min-width="120" align="left">
               <template slot-scope="{row}">
                 {{ row.payChannel | filterConst('CHANNEL_PAYMENT_CHANNEL') }}
               </template>
             </el-table-column>
             <el-table-column label="订单状态" min-width="100" align="left">
               <template slot-scope="{row}">
                 {{ row.orderStatus | filterOrderStatus }}
               </template>
             </el-table-column>
             <el-table-column label="下单时间" min-width="160" align="left">
               <template slot-scope="{row}">
                 {{ row.orderTime | filterTime }}
               </template>
             </el-table-column>
           </el-table>
        </el-tab-pane>
         <el-tab-pane label="最近提现" name="withdrawals">
           <div style="text-align: right; margin-bottom: 8px;">
             <el-button type="text" @click="viewAllWithdrawals">查看全部提现 <i class="el-icon-arrow-right"></i></el-button>
           </div>
           <el-table :data="recentWithdrawals" border height="calc(100vh - 480px)">
             <el-table-column label="提现编号" prop="withdrawalNo" min-width="150" align="left"></el-table-column>
             <el-table-column label="提现金额" min-width="100" align="left">
               <template slot-scope="{row}">
                 ￥{{ row.withdrawalAmount | filterMoney }}
               </template>
             </el-table-column>
             <el-table-column label="手续费" min-width="100" align="left">
               <template slot-scope="{row}">
                 ￥{{ row.serviceFee | filterMoney }}
               </template>
             </el-table-column>
             <el-table-column label="实际到账" min-width="100" align="left">
               <template slot-scope="{row}">
                 ￥{{ row.actualAmount | filterMoney }}
               </template>
             </el-table-column>
             <el-table-column label="支付宝账号" prop="alipayAccount" min-width="150" align="left"></el-table-column>
             <el-table-column label="审核状态" min-width="100" align="left">
               <template slot-scope="{row}">
                 <el-tag :type="getWithdrawalStatusType(row.auditStatus)">
                   {{ row.auditStatus | filterConst('CHANNEL_WITHDRAWAL_STATUS') }}
                 </el-tag>
               </template>
             </el-table-column>
             <el-table-column label="转账状态" min-width="100" align="left">
               <template slot-scope="{row}">
                 <el-tag v-if="row.transferStatus === 1" type="success">转账成功</el-tag>
                 <el-tag v-else-if="row.transferStatus === 2" type="danger">转账失败</el-tag>
                 <span v-else>-</span>
               </template>
             </el-table-column>
             <el-table-column label="申请时间" min-width="160" align="left">
               <template slot-scope="{row}">
                 {{ row.applyTime | filterTime }}
               </template>
             </el-table-column>
           </el-table>

        </el-tab-pane>
         <el-tab-pane label="最近流水" name="flows">
           <div style="text-align: right; margin-bottom: 8px;">
             <el-button type="text" @click="viewAllFlows">查看全部流水 <i class="el-icon-arrow-right"></i></el-button>
           </div>
           <el-table :data="recentFlows" border height="calc(100vh - 480px)">
             <el-table-column label="流水号" prop="financeNo" min-width="150" align="left"></el-table-column>
             <el-table-column label="类型" min-width="100" align="left">
               <template slot-scope="{row}">
                 <el-tag :type="getFlowType(row.type)" size="small">
                   {{ row.type | filterConst('CHANNEL_FLOW_TYPE') }}
                 </el-tag>
               </template>
             </el-table-column>
             <el-table-column label="金额" min-width="100" align="left">
               <template slot-scope="{row}">
                 <span :style="{ color: row.amount > 0 ? '#67C23A' : '#F56C6C' }">
                   {{ row.amount > 0 ? '+' : '' }}{{ row.amount | filterMoney }}
                 </span>
               </template>
             </el-table-column>
             <el-table-column label="余额" min-width="100" align="left">
               <template slot-scope="{row}">
                 ￥{{ row.balance | filterMoney }}
               </template>
             </el-table-column>
             <el-table-column label="关联类型" min-width="100" align="left">
               <template slot-scope="{row}">
                 <el-tag size="mini" type="info">{{ row.relatedType | filterConst('CHANNEL_FLOW_REF_TYPE') }}</el-tag>
               </template>
             </el-table-column>
             <el-table-column label="关联单号" prop="relatedNo" min-width="150" align="left"></el-table-column>
             <el-table-column label="备注" prop="remark" min-width="200" show-overflow-tooltip align="left"></el-table-column>
             <el-table-column label="创建时间" min-width="160" align="left">
               <template slot-scope="{row}">
                 {{ row.created | filterTime }}
               </template>
             </el-table-column>
           </el-table>

        </el-tab-pane>
      </el-tabs>
    </el-card>

    <!-- 编辑弹窗 -->
    <el-dialog title="编辑渠道信息" :visible.sync="editDialogVisible" width="600px" :close-on-click-modal="false">
      <el-form :model="editForm" :rules="editRules" ref="editForm" label-width="100px" size="small">
        <el-form-item label="姓名" prop="name">
          <el-input v-model="editForm.name" placeholder="请输入姓名" disabled></el-input>
          <div class="form-tip">姓名不可修改</div>
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input v-model="editForm.phone" placeholder="请输入手机号" maxlength="11"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input v-model="editForm.password" type="password" placeholder="留空则不修改密码" show-password clearable></el-input>
        </el-form-item>
        <el-form-item label="工作区域" prop="workArea">
          <el-select v-model="editForm.workArea" placeholder="请选择工作区域" filterable clearable style="width: 100%;">
            <el-option
              v-for="station in stationList"
              :key="station.value"
              :label="station.label"
              :value="station.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="支付宝账号" prop="alipayAccount">
          <el-input v-model="editForm.alipayAccount" placeholder="请输入支付宝账号"></el-input>
        </el-form-item>
        <el-form-item label="支付宝姓名" prop="alipayName">
          <el-input v-model="editForm.alipayName" placeholder="请输入支付宝姓名"></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input type="textarea" v-model="editForm.remark" :rows="3" placeholder="请输入备注信息" maxlength="200"
            show-word-limit>
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSaveEdit" :loading="editLoading">保存</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import idCardFrontPlaceholder from '@/assets/img/channel/id-card-front-placeholder.png'
import idCardBackPlaceholder from '@/assets/img/channel/id-card-back-placeholder.png'

export default {
  name: 'channelDetail',
  data() {
    return {
      channelId: this.$route.query.id,
      loading: false,
      activeTab: 'business',
      channelInfo: {},
      statistics: {
        monthOrderCount: 0,
        monthCommission: 0,
        monthWithdrawal: 0,
        pendingCommission: 0
      },
      recentOrders: [],
      recentWithdrawals: [],
      recentFlows: [],
      // 占位图片
      idCardFrontPlaceholder,
      idCardBackPlaceholder,
      // 编辑相关
      editDialogVisible: false,
      editLoading: false,
      organizationList: [],
      stationList: [],
      editForm: {
        id: '',
        name: '',
        phone: '',
        password: '',
        organizationId: '',
        workArea: '',
        alipayAccount: '',
        alipayName: '',
        remark: ''
      },
      editRules: {
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '手机号格式不正确', trigger: 'blur' }
        ],
        password: [
          { min: 6, message: '密码长度不能少于6位', trigger: 'blur' }
        ],
        workArea: [
          { required: true, message: '请输入工作区域', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    // 如果没有传入channelId，从列表获取第一个渠道
    if (!this.channelId) {
      this.$axios.get('/api/v1/channel/list', { page: 1, pageSize: 1 }).then(res => {
        if (res && res.code === 1 && res.data && res.data.list && res.data.list.length > 0) {
          this.channelId = res.data.list[0].id
          this.refresh()
        }
      })
    } else {
      this.refresh()
    }
  },
  methods: {
    refresh() {
      this.getChannelInfo()
      this.getRecentOrders()
      this.getRecentWithdrawals()
      this.getRecentFlows()
      this.getStatistics()
    },
    tabClick() {
      // Tab切换时可以加载数据
    },
    /**
     * 获取渠道详情
     * 作者：孙艺
     */
    async getChannelInfo() {
      this.loading = true
      try {
        const res = await this.$axios.get(`/api/v1/channel/detail`, { id: this.channelId })
        if (res && res.code === 1) {
          this.channelInfo = res.data
        }
      } finally {
        this.loading = false
      }
    },
    /**
     * 获取渠道最近订单
     * 使用接口：GET /api/v1/channel/recent/orders
     * 作者：孙艺
     */
    async getRecentOrders() {
      try {
        const res = await this.$axios.get('/api/v1/channel/recent/orders', {
          channelId: Number(this.channelId)
        })
        if (res && res.code === 1 && res.data) {
          this.recentOrders = Array.isArray(res.data) ? res.data : []
        }
      } catch (error) {
        console.error('获取最近订单失败:', error)
      }
    },
    /**
     * 获取渠道最近提现
     * 使用接口：GET /api/v1/channel/recent/withdrawals
     * 作者：孙艺
     */
    async getRecentWithdrawals() {
      try {
        const res = await this.$axios.get('/api/v1/channel/recent/withdrawals', {
          channelId: Number(this.channelId)
        })
        if (res && res.code === 1 && res.data) {
          this.recentWithdrawals = Array.isArray(res.data) ? res.data : []
        }
      } catch (error) {
        console.error('获取最近提现失败:', error)
      }
    },
    /**
     * 获取渠道最近流水
     * 使用接口：GET /api/v1/channel/recent/finance
     * 作者：孙艺
     */
    async getRecentFlows() {
      try {
        const res = await this.$axios.get('/api/v1/channel/recent/finance', {
          channelId: Number(this.channelId)
        })
        if (res && res.code === 1 && res.data) {
          this.recentFlows = Array.isArray(res.data) ? res.data : []
        }
      } catch (error) {
        console.error('获取最近流水失败:', error)
      }
    },
    /**
     * 获取渠道业务数据统计
     * 使用接口：GET /api/v1/channel/dashboard
     * 作者：孙艺
     */
    async getStatistics() {
      try {
        const res = await this.$axios.get('/api/v1/channel/dashboard', {
          channelId: Number(this.channelId)
        })
        if (res && res.code === 1 && res.data) {
          const data = res.data
          // 更新 channelInfo 中的累计数据
          this.channelInfo = {
            ...this.channelInfo,
            ...res.data,
            orderCount: data.totalOrderCount || 0,
            totalCommission: data.totalCommission || 0,
            totalWithdrawal: data.totalWithdrawal || 0,
            balance: data.accountBalance || 0
          }
          // 更新 statistics 中的月度数据
          this.statistics = {
            ...res.data,
            monthOrderCount: data.monthOrderCount || 0,
            monthCommission: data.monthCommission || 0,
            monthWithdrawal: data.monthWithdrawal || 0,
            pendingCommission: data.pendingCommission || 0
          }
        }
      } catch (error) {
        console.error('获取渠道业务数据统计失败:', error)
        this.$message.error('获取渠道业务数据统计失败')
      }
    },
    async handleEnable() {
      await this.$confirm('确定要启用该渠道吗？', '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'info' })
      const res = await this.$axios.post('/api/v1/channel/updateStatus', { id: this.channelInfo.id, status: 1 })
      if (res && res.code === 1) {
        this.$message.success('启用成功')
        this.getChannelInfo()
      }
    },
    async handleDisable() {
      await this.$confirm('确定要禁用该渠道吗？禁用后渠道将无法使用APP', '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' })
      const res = await this.$axios.post('/api/v1/channel/updateStatus', { id: this.channelInfo.id, status: 2 })
      if (res && res.code === 1) {
        this.$message.success('禁用成功')
        this.getChannelInfo()
      }
    },
    goBack() {
      this.$router.go(-1)
    },
    viewAllOrders() {
      this.$router.push({
        path: '/channelOrder',
        query: { channelId: this.channelId }
      })
    },
    viewAllWithdrawals() {
      this.$router.push({
        path: '/channelWithdrawal',
        query: { channelId: this.channelId }
      })
    },
    viewAllFlows() {
      this.$router.push({
        path: '/channelFinancial',
        query: { channelId: this.channelId }
      })
    },
    getStatusType(status) {
      const statusItem = this.$const.CHANNEL_STATUS.find(i => i.value === status)
      return statusItem ? statusItem.type : ''
    },
    getAuditStatusType(status) {
      const statusItem = this.$const.CHANNEL_AUDIT_STATUS.find(i => i.value === status)
      return statusItem ? statusItem.type : ''
    },
    getWithdrawalStatusType(status) {
      const statusItem = this.$const.CHANNEL_WITHDRAWAL_STATUS.find(i => i.value === status)
      return statusItem ? statusItem.type : ''
    },
    getFlowType(type) {
      const typeItem = this.$const.CHANNEL_FLOW_TYPE.find(i => i.value === type)
      return typeItem ? typeItem.type : ''
    },
    /**
     * 编辑渠道信息
     * 作者：孙艺
     */
    handleEdit() {
      this.editForm = {
        id: this.channelInfo.id,
        name: this.channelInfo.name,
        phone: this.channelInfo.phone,
        password: '',
        workArea: this.channelInfo.workArea,
        alipayAccount: this.channelInfo.alipayAccount || '',
        alipayName: this.channelInfo.alipayName || '',
        remark: this.channelInfo.remark || ''
      }
      this.loadStationList()
      this.editDialogVisible = true
    },
    /**
     * 加载机构列表
     * 作者：孙艺
     */
    async loadOrganizationList() {
      const res = await this.$axios.get('/api/v1/manage/organization/queryByAdminId')
      if (res && res.code === 1) {
        this.organizationList = res.data || []
      }
    },
    /**
     * 加载场站列表
     * 作者：孙艺
     */
    async loadStationList() {
      const appKey = this.mixinUserInfo?.appKey
      this.stationList = await this.mixinGetStationList(appKey)
    },
    /**
     * 保存编辑
     * 作者：孙艺
     */
    handleSaveEdit() {
      this.$refs.editForm.validate(async (valid) => {
        if (valid) {
          this.editLoading = true
          try {
            // 如果密码不为空，则进行 sha256 加密
            const formData = {
              ...this.editForm
            }
            if (formData.password) {
              formData.password = this.$utils.sha256Fn(formData.password)
            } else {
              // 如果密码为空，则不传递密码字段
              delete formData.password
            }

            const res = await this.$axios.post('/api/v1/channel/update', formData)
            if (res && res.code === 1) {
              this.$message.success('保存成功')
              this.editDialogVisible = false
              this.getChannelInfo()
            } else {
              this.$message.error(res.msg || '保存失败')
            }
          } finally {
            this.editLoading = false
          }
        }
      })
    },
    /**
     * 获取身份证图片完整URL
     * 作者：孙艺
     * @param {String} imageKey - 图片key（hash）
     * @returns {String} 完整的图片URL
     */
    getIdCardImageUrl(imageKey) {
      if (!imageKey) {
        return ''
      }
      // 如果已经是完整URL（包含http或https），直接返回
      if (imageKey.startsWith('http://') || imageKey.startsWith('https://') || imageKey.startsWith('data:')) {
        return imageKey
      }
      // 拼接七牛云前缀
      return window.configure.qiniuUrl + imageKey
    },
    previewImage(type) {
      // 图片预览功能，el-image组件已内置预览
    }
  }
}
</script>

<style lang="less" scoped>
@import '../channel.less';

// 页面容器
.channel-detail {
  height: 100%;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background: #dcdfe6;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }
}

// 顶部操作栏
.detail-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fff;
  padding: 16px 20px;
  border-radius: 8px;
  margin-bottom: 16px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);

  .header-left {
    display: flex;
    align-items: center;

    .header-title {
      font-size: 18px;
      font-weight: 600;
      color: #303133;
      margin-left: 16px;
    }
  }

  .header-right {
    display: flex;
    gap: 10px;

    .el-button {
      border-radius: 6px;
    }
  }
}

// 信息区域
.info-section {
  margin-bottom: 16px;
  display: flex;

  .el-col {
    display: flex;
  }
}

.info-card {
  width: 100%;
  display: flex;
  flex-direction: column;
  border-radius: 8px;

  /deep/ .el-card__header {
    padding: 14px 20px;
    border-bottom: 1px solid #EBEEF5;
    background: linear-gradient(135deg, #f8fafc 0%, #fff 100%);
  }

  /deep/ .el-card__body {
    flex: 1;
    padding: 20px;
  }

  .card-header-new {
    font-size: 15px;
    font-weight: 600;
    color: #303133;
    display: flex;
    align-items: center;

    i {
      margin-right: 8px;
      font-size: 16px;
      color: #409EFF;
    }
  }

  .info-value {
    color: #303133;
    font-weight: 500;
  }

  /deep/ .el-descriptions-item__label {
    width: 100px;
    min-width: 100px;
    background: #fafafa;
  }

  /deep/ .el-descriptions-item__content {
    min-width: 120px;
  }

  /deep/ .el-descriptions {
    border-radius: 6px;
    overflow: hidden;
  }
}

// 证件照片卡片
.photo-card {
  display: flex;
  flex-direction: column;

  /deep/ .el-card__body {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
}

// 图片展示区域
.image-gallery {
  display: flex;
  gap: 16px;
  flex: 1;

  .image-item {
    flex: 1;
    display: flex;
    flex-direction: column;

    .image-label {
      font-size: 12px;
      color: #606266;
      margin-bottom: 8px;
      text-align: center;
      font-weight: 500;
    }

    .image-wrapper {
      flex: 1;
      border-radius: 8px;
      overflow: hidden;
      cursor: pointer;
      border: 1px dashed #DCDFE6;
      transition: all 0.3s;
      background: #fafafa;

      &:hover {
        border-color: #409EFF;
        border-style: solid;
        box-shadow: 0 4px 12px rgba(64, 158, 255, 0.15);
      }

      &.id-card-wrapper {
        // 身份证图片比例 1.56:1 (宽度:高度 = 1.56:1)
        // 使用 padding-bottom 技巧：高度 = 宽度 / 1.56
        width: 100%;
        padding-bottom: calc(100% / 1.56);
        position: relative;
        height: 0;

        .el-image {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
        }
      }

      &:not(.id-card-wrapper) {
        min-height: 120px;

        .el-image {
          width: 100%;
          height: 100%;
        }
      }
    }

    .image-placeholder {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      background: #fafafa;
      color: #c0c4cc;
      position: absolute;
      top: 0;
      left: 0;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      i {
        font-size: 32px;
        margin-bottom: 8px;
      }

      span {
        font-size: 12px;
      }
    }
  }
}

// 标签页卡片
.tabs-card {
  border-radius: 8px;

  /deep/ .el-card__body {
    padding: 20px;
  }

  /deep/ .el-tabs__header {
    margin-bottom: 20px;
  }

  /deep/ .el-tabs__nav-wrap::after {
    height: 1px;
  }

  /deep/ .el-table {
    border-radius: 6px;
    overflow: hidden;

    th {
      background: #fafafa;
    }
  }
}

// 统计卡片额外样式
.stat-card {
  &.balance .stat-icon {
    background: linear-gradient(135deg, #409EFF 0%, #66B1FF 100%);
  }
}

// 表单提示
.form-tip {
  font-size: 12px;
  color: #909399;
  margin-top: 4px;
}

.ml-10 {
  margin-left: 10px;
}
</style>
